import common from './common.json';
import details from './details.json';

export default {
  common,
  details,
};
